import type { FaireProductEntity } from "../../entity_types/product";

export const p_uvzw98w247: FaireProductEntity = {
  token: "p_uvzw98w247",
  type: "product",
  name: "GROWN - Split Toe Clog, Buckle Detail",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/00105ddae32fd05192c0b04231d37064f667cbd551b4e0a8e5e762339ba5e7d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe4700162cc90b046902b04c5a0d160f15c97ed766802035a7231d6271c69f16.jpeg",
    "https://cdn.faire.com/fastly/01556942911dd2d5118d37ed3a18e5a37ffa29f747afbf696687d9320d387fe1.jpeg",
    "https://cdn.faire.com/fastly/38653fd088b0e584abaebbde61c11da0c07fc84d2cd492ed9afe4fc2fa62897f.jpeg",
  ],
  priceDollars: 13,
  description:
    "A modern take on the classic clog, this split-toe mule features a soft faux suede upper, an adjustable buckle strap, and a lightweight comfort sole for effortless everyday wear. Equal parts laid-back and fashion-forward, it's the perfect slip-on to elevate casual looks. Available in black, camel, and cream.\n\nOOTD\nStyle them with relaxed straight-leg denim, a ribbed tank, and an oversized button-down for an easy off-duty look. Finish with a canvas tote, simple gold jewelry, and sleek sunglasses for that effortlessly cool, everyday vibe.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:07.344Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
